import React from 'react'
import { string, func } from 'prop-types'
import ModalWrapper from './modal-wrapper'
import ConfirmationMsg from '../messages/confirmation-msg'
import HeadingBeta from '../headings/heading-beta'
import Subtitle from '../texts/subtitle'

const DeleteModal = props => {
  const { title, subtitle, onAccept, onCancel } = props

  return (
    <ModalWrapper onClose={onCancel}>
      <ConfirmationMsg
        className='no-top-space'
        hasActions
        FlatButton
        CtaButton
        flatText='cancel'
        ctaText='delete'
        hasIcon
        iconName='delete-bin'
        onCancel={onCancel}
        onAccept={onAccept}
      >
        <HeadingBeta>{title || 'Delete item'}</HeadingBeta>
        <Subtitle hasEmphasisText={false}>
          {subtitle || 'Are you sure you want to delete this item?'}
        </Subtitle>
      </ConfirmationMsg>
    </ModalWrapper>
  )
}

DeleteModal.propTypes = {
  title: string,
  subtitle: string,
  onAccept: func,
  onCancel: func
}

export default DeleteModal



// WEBPACK FOOTER //
// ./src/ui/modal/delete-modal.js